import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const offersApi = createApi({
  reducerPath: "offersApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/company`,
  }),
  tagTypes: ["Offers"],
  endpoints: builder => ({
    fetchOffers: builder.query({
      query: ({ company_id, status, page = 1, page_size = 10, sort_by, order }) => ({
        url: `/${company_id}/offers/list/?statuses=${status}&page=${page}&page_size=${page_size}${sort_by ? `&sort_by=${sort_by}` : ""
          }${order ? `&order=${order}` : ""}`,
        method: "GET",
      }),
      providesTags: ["Offers"],
    }),
    // fetchOffers: builder.query({
    //   query: ({ company_id, status, page = 1, page_size = 10 }) => ({
    //     url: `/${company_id}/offers/list/?statuses=${status}&page=${page}&page_size=${page_size}`,
    //     method: "GET",
    //   }),
    //   providesTags: ["Offers"],
    // }),
    fetchComparatorData: builder.query({
      query: ({ company_id, offer_id }) => ({
        url: `/${company_id}/offer/${offer_id}/comparator-data/`,
        method: "GET",
      }),
    }),
    fetchAutoPopulateData: builder.query({
      query: ({ company_id, offer_id, manual = false }) => ({
        url: `/${company_id}/offer/${offer_id}/auto-populate-data/`,
        method: "GET",
        extraOptions: { manual }, // 👈 attach flag
      }),
    }),
    fetchCurrencyRate: builder.query({
      query: ({ offer_id, company_id, code }) => {
        return {
          url: `/${company_id}/offer/${offer_id}/currency/${code}`,
          method: "GET",
        };
      },
    }),

    fetchOfferCurrencyRate: builder.query({
      query: ({ offer_id, company_id, code }) => {
        return {
          url: `/${company_id}/offer/${offer_id}/currency/${code}`,
          method: "GET",
        };
      },
    }),

    fetchStiCurrencyRate: builder.query({
      query: ({ offer_id, company_id, code }) => {
        return {
          url: `/${company_id}/offer/${offer_id}/currency/${code}`,
          method: "GET",
        };
      },
    }),

    fetchOfferById: builder.query({
      query: ({ company_id, id }) => ({
        url: `/${company_id}/offer/${id}/`,
        method: "GET",
      }),
    }),
    createOfferDetails: builder.mutation({
      query: ({ company_id, body }) => ({
        url: `/${company_id}/offer/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Offers"],
    }),
    updateOfferDetails: builder.mutation({
      query: ({ company_id, body, id }) => ({
        url: `/${company_id}/offer/${id}/position-detail/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Offers"],
    }),
    createCandidateDetails: builder.mutation({
      query: ({ company_id, id, body }) => ({
        url: `/${company_id}/offer/${id}/candidate-detail/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Offers"],
    }),
    createOfferModeller: builder.mutation({
      query: ({ company_id, id, body }) => ({
        url: `/${company_id}/offer/${id}/offer-modeller/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Offers"],
    }),
    updateOfferStatus: builder.mutation({
      query: ({ company_id, id, status, body = {} }) => ({
        url: `/${company_id}/offer/${id}/?status=${status}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Offers"],
    }),
    sendEmail: builder.mutation({
      query: ({
        company_id,
        id,
        status,
        type = "annual",
        show_current = true,
      }) => ({
        url: `/${company_id}/offer/${id}/email-page/?type=${type}&show_current=${show_current}`,
        method: "POST",
      }),
      invalidatesTags: ["Offers"],
    }),
    fetchEmailPreview: builder.query({
      query: ({ company_id, id, type = "annual", show_current = true }) => ({
        url: `/${company_id}/offer/${id}/email-page/?type=${type}&show_current=${show_current}`,
        method: "GET",
      }),
    }),

    // step 1 khurram
    reviseOffer: builder.mutation({
      query: ({ company_id, id, body }) => ({
        url: `/${company_id}/offer/${id}/revise/`,
        method: "POST",
        body,
      }),
    }),
    deleteDraftOffer: builder.mutation({
      query: ({ company_id, id }) => ({
        url: `/${company_id}/offer/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Offers"],
    }),
    emailPdfInstall: builder.query({
      query: ({ company_id, id }) => ({
        url: `/${company_id}/offer/${id}/email-page/pdf/`,
        method: "GET",
      }),
    }),
    // fecth grade by country id
    // fetchJobGradesByCountry: builder.query({
    //   query: ({ company_id, countries_id }) => ({
    //     url: `/${company_id}/job-grades/all?countries=${countries_id.toString()}`,
    //     method: "GET",
    //   }),
    // }),
    fetchRangeType: builder.query({
      query: ({ company_id, grade, country_id }) => ({
        url: `/${company_id}/range_type/?grade=${grade}&country_id=${country_id}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useFetchOffersQuery,
  useFetchComparatorDataQuery,
  useCreateCandidateDetailsMutation,
  useCreateOfferDetailsMutation,
  useFetchOfferByIdQuery,
  useUpdateOfferDetailsMutation,
  useFetchCurrencyRateQuery,
  useFetchOfferCurrencyRateQuery,
  useCreateOfferModellerMutation,
  useUpdateOfferStatusMutation,
  useFetchAutoPopulateDataQuery,
  useLazyFetchAutoPopulateDataQuery,
  useFetchStiCurrencyRateQuery,
  useSendEmailMutation,
  useFetchEmailPreviewQuery,
  useEmailPdfInstallQuery,
  // step 2 khurram
  useReviseOfferMutation,
  useFetchRangeTypeQuery,
  // useFetchJobGradesByCountryQuery,
  useDeleteDraftOfferMutation,
} = offersApi;
